export const RECEIVE_PRODUCT_INFO = 'RECEIVE_PRODUCT_INFO';
export const RECEIVE_PACKAGE_LIST = 'RECEIVE_PACKAGE_LIST';
export const SELECT_PACKAGE = 'SELECT_PACKAGE';
export const CHANGE_PACKAGE_BUY_COUNT = 'CHANGE_PACKAGE_BUY_COUNT';
export const RECEIVE_COMMENT = 'RECEIVE_COMMENT';
export const CHANGE_COMMENT_PAGE = 'CHANGE_COMMENT_PAGE';
export const CHANGE_COMMENT_TYPE = 'CHANGE_COMMENT_TYPE';
export const LOADING_COMMENT_START = 'LOADING_COMMENT_START';
export const LOADING_COMMENT_END = 'LOADING_COMMENT_END';
export const LOADING_SCROLL_START = 'LOADING_SCROLL_START';
export const LOADING_SCROLL_END = 'LOADING_SCROLL_END';
export const TOGGLE_DISPATCH_TYPE = 'TOGGLE_DISPATCH_TYPE';
export const SELECT_SELFPICKUP_SPOT = 'SELECT_SELFPICKUP_SPOT';
export const EDIT_MEMO = 'EDIT_MEMO';
export const LOADING_CUSTOMER_ADDRESS_START = 'LOADING_CUSTOMER_ADDRESS_START';
export const LOADING_CUSTOMER_ADDRESS_END = 'LOADING_CUSTOMER_ADDRESS_END';
export const RECEIVE_CUSTOMER_ADDRESS = 'RECEIVE_CUSTOMER_ADDRESS';
export const SELECT_CUSTOMER_ADDRESS = 'SELECT_CUSTOMER_ADDRESS';
export const SAVING_CUSTOMER_ADDRESS_START = 'SAVING_CUSTOMER_ADDRESS_START';
export const SAVING_CUSTOMER_ADDRESS_END = 'SAVING_CUSTOMER_ADDRESS_END';
export const SAVE_CUSTOMER_ADDRESS_SUCCEED = 'SAVE_CUSTOMER_ADDRESS_SUCCEED';
export const RECEIVE_AREA_LIST = 'RECEIVE_AREA_LIST';
export const RECEIVE_TOKEN = 'RECEIVE_TOKEN';
export const RECEIVE_TOKEN_FAILED = 'RECEIVE_TOKEN_FAILED';
export const GO_LOGIN = 'GO_LOGIN';
export const RECEIVE_CHANNEL_INFO = 'RECEIVE_CHANNEL_INFO';
export const RECEIVE_LIST_BASEINFO = 'RECEIVE_LIST_BASEINFO';
export const RESET_PRODUCT_INFO = 'RESET_PRODUCT_INFO';
export const RECEIVE_CAT_LIST = 'RECEIVE_CAT_LIST';
export const ADD_FAVORITE = 'ADD_FAVORITE';
export const DELETE_FAVORITE = 'DELETE_FAVORITE';
export const CHANGE_JOURNEYID = 'CHANGE_JOURNEYID';
export const APPEND_PKGS = 'APPEND_PKGS';
export const WAIT_LOGIN = 'WAIT_LOGIN';
export const SAVE_ORDER_BASE_INFO = 'SAVE_ORDER_BASE_INFO';
export const CHANGE_BOOK_START_PRICE = 'CHANGE_BOOK_START_PRICE';
export const ADD_JOURNEY_DATA = 'ADD_JOURNEY_DATA';
export const LOAD_TOURIST = 'LOAD_TOURIST';
export const DELETE_TOURIST = 'DELETE_TOURIST';
export const CREAT_ORDERID = 'CREAT_ORDERID';
export const CREAT_CONTACTS_INFO = 'CREAT_CONTACTS_INFO';
export const CHANGE_PERSON_INFO = 'CHANGE_PERSON_INFO';
export const LOAD_TRAVELLER_ATTR = 'LOAD_TRAVELLER_ATTR';   //出游人扩展属性
export const CHANGE_TRALLER_ATTR_CONFIG = 'CHANGE_TRALLER_ATTR_CONFIG'; //自定义属性
export const CHANGE_ORDER_ATTR_INFO = 'CHANGE_ORDER_ATTR_INFO'; //  服务信息
export const CHANGE_FREQUENT_TRAVELLER_INFO = 'CHANGE_FREQUENT_TRAVELLER_INFO'; //常用旅客
export const QUERY_INVOICE_RULE = 'QUERY_INVOICE_RULE';
export const ADD_INVOICE_INFO = 'ADD_INVOICE_INFO';
export const QUERY_PLANE_INFO = 'QUERY_PLANE_INFO';
export const CREATE_BARGAIN_FAVORITE = 'CREATE_BARGAIN_FAVORITE';
export const GET_BOOKING_ATTR = "GET_BOOKING_ATTR";
// 改变出发城市code
export const CHANGE_DEPART_CITY_CODE = 'CHANGE_DEPART_CITY_CODE';
// 改变出发城市名称
export const CHANGE_DEPART_CITY_NAME = 'CHANGE_DEPART_CITY_NAME';
// 更新联运城市真实出发城市列表
export const CHANGE_REAL_DEPART_CITY_LIST = 'CHANGE_REAL_DEPART_CITY_LIST';
export const LOAD_COMMENT_FLAG = 'LOAD_COMMENT_FLAG'//评论请求加载阀门
export const GET_PRODUCT_INFORMATIONS = 'GET_PRODUCT_INFORMATIONS'



// WEBPACK FOOTER //
// libs/store/mutation-types.js